import { Component, OnInit } from '@angular/core';
import { SignInComponent } from '../user/sign-in/sign-in.component';

@Component({
    selector: 'app-start',
    templateUrl: './start.component.html',
    styleUrls: ['./start.component.css'],
    imports: [SignInComponent]
})
export class StartComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}
